import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { useCancelEvent } from "@/hooks/useEvents";
import { useNavigate } from "react-router-dom";

interface CancelEventDialogProps {
  eventId: string;
  eventTitle: string;
}

export const CancelEventDialog = ({ eventId, eventTitle }: CancelEventDialogProps) => {
  const cancelEventMutation = useCancelEvent();
  const navigate = useNavigate();

  const handleCancel = () => {
    cancelEventMutation.mutate(eventId, {
      onSuccess: () => {
        navigate('/events');
      },
    });
  };

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button variant="destructive">Cancel Event</Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Cancel Event</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to cancel "{eventTitle}"? This action cannot be undone.
            All participants will be notified.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Go Back</AlertDialogCancel>
          <AlertDialogAction
            onClick={handleCancel}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            Yes, Cancel Event
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
